// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonInputText{
    /*margin-bottom: 7px;*/
}

.commonInputText_label{
    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 150%;

    color: #3B4256;
    margin-bottom: 5px;
}                              
                                
.commonInputText_field{
    border: none;
    width: 100%;
    height: 39px;
    background: #F3F6FF;
    border-radius: 30px;

    font-weight: 400;
    font-size: calc(10px * var(--fontScaler));
    line-height: 150%;
    /*color: #B8BCCA;*/
    color: #3B4256;
    padding: 0px 20px;
}     
.commonInputText_field:focus{
    outline-color: #3B4256;
}

.commonInputText--error .commonInputText_field{
    outline: 1px solid #E23424;
}

.commonInputText_field:focus{
    outline-width: 2px;
}

.commonInputText_error{
    font-weight: 400;
    font-size: calc(10px * var(--fontScaler));
    line-height: 20px;
    height: 14px;
    color: #E23424;
}`, "",{"version":3,"sources":["webpack://./src/components/inputText/InputText.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;;IAEnB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,YAAY;IACZ,cAAc;AAClB","sourcesContent":[".commonInputText{\n    /*margin-bottom: 7px;*/\n}\n\n.commonInputText_label{\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 150%;\n\n    color: #3B4256;\n    margin-bottom: 5px;\n}                              \n                                \n.commonInputText_field{\n    border: none;\n    width: 100%;\n    height: 39px;\n    background: #F3F6FF;\n    border-radius: 30px;\n\n    font-weight: 400;\n    font-size: calc(10px * var(--fontScaler));\n    line-height: 150%;\n    /*color: #B8BCCA;*/\n    color: #3B4256;\n    padding: 0px 20px;\n}     \n.commonInputText_field:focus{\n    outline-color: #3B4256;\n}\n\n.commonInputText--error .commonInputText_field{\n    outline: 1px solid #E23424;\n}\n\n.commonInputText_field:focus{\n    outline-width: 2px;\n}\n\n.commonInputText_error{\n    font-weight: 400;\n    font-size: calc(10px * var(--fontScaler));\n    line-height: 20px;\n    height: 14px;\n    color: #E23424;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
